import QRCode from 'qrcode.react';

interface IQrcodeWithPdf {
  valueQrcode: string;
}

export function QrcodeWithPdf({ valueQrcode }: IQrcodeWithPdf) {
  return (
    <>
      <div className="d-flex justify-content-center mt-3">
        <QRCode value={valueQrcode} size={150} className="rounded-3" />
      </div>
      {/* <div
        className={`${styles.contentTextQrCode} d-flex justify-content-center align-items-center mt-3 p-3`}
      >
        <i className="material-icons-outlined me-3 color-text">file_download</i>
        <a
          className={styles.textQrCode}
          href={urlDownload}
          download="download.pdf"
        >
          <span className={styles.textQrCode}>
            Ou mostre o código ao seu indicado e peça a ele para apontar a
            câmera do celular para o{' '}
            <span className={`fw-semibold ${styles.textQrCode}`}>QR Code</span>{' '}
            acima.
          </span>
        </a>
      </div> */}

      {valueQrcode && (
        <QRCode
          style={{ display: 'none' }}
          id="canvas-qrcode-validation-code"
          value={valueQrcode}
          size={600}
          className="text-center qrcode"
        />
      )}
    </>
  );
}
